import { render, staticRenderFns } from "./ValidationError.vue?vue&type=template&id=d046050c"
import script from "./ValidationError.vue?vue&type=script&lang=ts"
export * from "./ValidationError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports